<template>
  <div class="max-w-full lg:max-w-3xl mx-auto px-12 lg:px-0">
    <div class="text-2xl font-light text-gray-800">
      Your information has been successfully submitted.
    </div>

    <div class="mt-4 text-base">
      Thank you. Your information has been submitted and we will get in touch with you very shortly.
    </div>
	</div>
</template>

<script>
  export default {

    data() {
      return {
        hasFund: null,
        deposit: null,
        lead   : null
      }
    },

    // created() {
    //   if(this.$route.params.data != null) {
    //     this.lead = JSON.parse(decodeURIComponent(this.$route.params.data))
    //   } else {
    //     this.lead = {}
    //   }

    //   if(this.lead.hasFund != null) {
    //     this.hasFund = this.lead.hasFund
    //   }

    //   if(this.lead.deposit != null) {
    //     this.deposit = this.lead.deposit
    //   }
    // },

  	methods : {

      canGoNext() {
        return this.hasFund != null
      },

      next() {
        let valid = true

        // this.borrowAmountError = null
        // this.spendAmountError  = null
        
        // if(this.firstName == null || this.firstName.length == 0) {
        //   this.firstNameError = "Please type a valid first name."
        //   valid = false
        // }

        if(valid) {
          this.lead.hasFund = this.hasFund
          this.lead.deposit = this.deposit

          this.$router.push({
            name  : 'client-lead-capture-credit-history',
            params: {
              data : encodeURIComponent(JSON.stringify(this.lead))
            }
          })
        }
      }
  	}
  }
</script>